import { IComponentController } from 'angular';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';

interface IPageDO0026 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    monoOccurrence: IMonoOccurrence;
    formulaireTel: IFormulaire;
    rdgMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rdlMultiOccurrenceOptions: IMultiOccurrenceOptions;
    rdpMultiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Do0026Controller(
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    rr0017Route: IRoute,
    MenuItemEcran: IMenuItemEcranClass,
) {
    const vm: IPageDO0026 = this;

    vm.monoOccurrenceOptions = {
        formulaire: new Formulaire(
            'LBL_BLC_RDD', [
                new FormulaireItem('rglcleint'),
                new FormulaireItem('rddflgdsp', { default: 1 }),
                new FormulaireItem('demcleint'),
                new FormulaireItem('rddflgcomimp'),
                new FormulaireItem('rdddatvig', { largeur: 33.33 }),
                new FormulaireItem('rddcom', { largeur: 66.66, enableCount: true })
            ]
        )
    };

    vm.formulaireTel = new Formulaire('', [
        new FormulaireItem('aut__rddtel1', {
            menu:
                [
                    new MenuItemEcran(
                        'G_LBL_COMREQ',
                        rr0017Route.NAME,
                        (data: any) => ({
                            id: data.aut__etlcleint1
                        }),
                        {
                            icon: 'launch',
                            iconButton: true,
                            fonction: 'BOUTEL'
                        }
                    )
                ]
        }),
        new FormulaireItem('aut__rddtel2', {
            menu:
                [
                    new MenuItemEcran(
                        'G_LBL_COMREQ',
                        rr0017Route.NAME,
                        (data: any) => ({
                            id: data.aut__etlcleint2
                        }),
                        {
                            icon: 'launch',
                            iconButton: true,
                            fonction: 'BOUTEL'
                        }
                    )
                ]
        })
    ], { largeurDefaut: 100 });

    vm.rdgMultiOccurrenceOptions = {
        bloc: 'rdg',
        fonctions: {
            boutonDupliquer: false
        },
        colonnesVisibles: [
            { nom: 'grecod', largeur: 100 },
            { nom: 'gredsc', largeur: 100 },
        ],
        formulaire: new Formulaire([
            new FormulaireItem('grecleint')
        ])
    };

    vm.rdlMultiOccurrenceOptions = {
        bloc: 'rdl',
        fonctions: {
            boutonDupliquer: false
        },
        colonnesVisibles: [
            { nom: 'litcod', largeur: 100 },
            { nom: 'litdsc', largeur: 100 },
        ],
        formulaire: new Formulaire([
            new FormulaireItem('litcleint')
        ])
    };

    vm.rdpMultiOccurrenceOptions = {
        bloc: 'rdp',
        colonnesVisibles: [
            { nom: 'vacvalcle', largeur: 100 },
            { nom: 'vacrgpcod_dsc', largeur: 250 },
            { nom: 'rdpflgdim', largeur: 130 },
            { nom: 'rdpflglun', largeur: 130 },
            { nom: 'rdpflgmar', largeur: 130 },
            { nom: 'rdpflgmer', largeur: 130 },
            { nom: 'rdpflgjeu', largeur: 130 },
            { nom: 'rdpflgven', largeur: 130 },
            { nom: 'rdpflgsam', largeur: 130 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('vacrgpcod', {
                resourceParams: () => {
                    return { rglcleint: vm.monoOccurrence.data.rglcleint };
                }
            }),
            new FormulaireItem('rdpflgdim'),
            new FormulaireItem('rdpflglun'),
            new FormulaireItem('rdpflgmar'),
            new FormulaireItem('rdpflgmer'),
            new FormulaireItem('rdpflgjeu'),
            new FormulaireItem('rdpflgven'),
            new FormulaireItem('rdpflgsam')
        ])
    };    
}
